export default __webpack_public_path__ + "static/lamina-32fa07bef05db40d6021b9b3e0fd3eb0.png";